import { Company } from '../../models/company';
import { MatDialog } from '@angular/material/dialog';
import { AdComponent } from './ad/ad.component';
import { DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import { CompanyService } from '../../services/company.service';
import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-company-stand',
    templateUrl: './company-stand.component.html',
    styleUrls: ['./company-stand.component.scss']
})
export class CompanyStandComponent implements OnInit {
    company: Company;

    constructor(private dialog: MatDialog,
        private companyService: CompanyService,
        private activeRoute: ActivatedRoute,
        public sanitizer: DomSanitizer) {
        const id = this.activeRoute.snapshot.paramMap.get('id');
        this.companyService.getCompanyStand(id).then(res => {
            let tempCompany: Company = res;
            // TODO: Change contact info storage format to avoid innerHTML stuff.
            // One good option is to store contact info as an object with two fields "text" and "url" in the backend
            // and parse it from JSON in frontend. This will allow all contact infos to be buttons which will look much better
            tempCompany.contactInfo = tempCompany.contactInfo.replace(/<a/g, "<a style='text-decoration:none;'");
            this.company = tempCompany;
        }).catch(console.error);
    }

    ngOnInit(): void {
    }

    openAd(i: number): void {
        this.dialog.open(AdComponent, {
            data: {
                image: this.company.adList[i].imagePath,
                title: this.company.adList[i].title,
                description: this.company.adList[i].description
            },
            autoFocus: false
        });
    }
}
